import React from "react"
import {Form as BootstrapForm, FormProps} from "react-bootstrap"

interface Props extends FormProps {
  form?: string
}

const Form: React.FC<Props> = (props) => {
  return <BootstrapForm onSubmit={(e: React.FormEvent<BootstrapForm>) => e.preventDefault()} horizontal {...props} />
}

export default Form
